import React from 'react';

interface BetaLaunchBannerProps {
    variant?: 'hero' | 'compact';
}

const BetaLaunchBanner: React.FC<BetaLaunchBannerProps> = ({ variant = 'compact' }) => {
    const isHero = variant === 'hero';
    const containerClasses = isHero
        ? 'rounded-xl border border-accent/30 bg-accent/10 px-4 py-4 text-sm leading-relaxed'
        : 'rounded-lg border border-accent/30 bg-accent/10 px-4 py-3 text-sm';
    const badgeClasses = isHero
        ? 'inline-flex items-center rounded-full border border-accent px-2.5 py-1 text-xs font-semibold tracking-[0.14em] uppercase text-accent'
        : 'inline-flex items-center rounded-full border border-accent px-2 py-0.5 text-[11px] font-semibold tracking-[0.14em] uppercase text-accent';

    return (
        <div className={containerClasses} role="status" aria-live="polite">
            <div className={`mb-2 ${isHero ? '' : 'mb-1'}`}>
                <span className={badgeClasses}>Beta</span>
            </div>
            <p className="text-content font-medium">Flowium is now in public beta.</p>
            <p className="text-content-secondary mt-1">
                We're actively hardening the product and polishing the experience based on real-world feedback.
            </p>
        </div>
    );
};

export default BetaLaunchBanner;
